import React,{useEffect} from "react";
import Helmet from "react-helmet";
import Footer from "./footer";
import Header from "./header";
import {useSelector,useDispatch} from "react-redux"
import {getMarket} from '../state/action'
import {Link} from "react-router-dom"
function Market() {
  const  market  = useSelector((state) =>state.gemstone.market);
 
const dispatch = useDispatch();
console.log(market)
useEffect(() => {
  dispatch(getMarket());

}, []);

  return (
    <div>
      <Header />
      <section
        className="page-title centred"
        style={{
          backgroundImage: "url(https://images.unsplash.com/photo-1627289601745-5813e24c9bc1?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=774&q=80)",
        }}
      >
        <div className="auto-container">
          <div className="content-box">
            <div className="title">
              <h1>Gemstone In Ethiopia Market</h1>
            </div>
            <ul className="bread-crumb clearfix">
              <li>
                <Link to="/">Home</Link>
              </li>
             
            </ul>
          </div>
        </div>
      </section>

      <section className="service-details">
        <div className="auto-container">
          <div className="row clearfix">
            <div className="col-lg-3 col-md-12 col-sm-12 sidebar-side">
              <div className="service-sidebar">
              
              </div>
            </div>
         
              <div className="col-lg-12 col-md-12 col-sm-12 content-side">
              <div className="service-details-content">
                <div className="text">
                  <h2>Ethiopian Gem Market</h2>
                  <p>
                  Gemstones never played a significant role in the ancient Ethiopian history. The last two decades   are the emerge of gemstones in Ethiopia. The recent years brings the exciting news in the gemstone area for the Ethiopians. Precious and semi-precious gemstone have been reported to be found in the country. Ethiopia is landlocked eastern African country with fertile grassland,great lakes and massive canyons. Ethiopia is known as a land of origin. It is a land of plenty of resources. Concerning gemstones opals lead the pack. Currently Ethiopian opal is the second  high quality opal, next to Australia in the world.The country is known to have significant deposits of gemstones like opal, emerald, sapphires,rubies, amber, beryl. New discoveries have brought Ethiopia’s total reported gems up to over 40. A recent survey increased estimates of goad resources to 500 tones. The government says the production could rise up to 40 tonnes a year. Ethiopian’s gemstones potential exceptionally promising. Ethiopia has become a great producer of opal, emerald and sapphire.
                  </p>
                </div>
                
                

                  
              </div>
            </div>
           
           
          </div>
        </div>
        <section className="feature-style-two sec-pad-2">
          <div className="auto-container" >
            <div className="inner-container mr-0 clearfix">
              
            {market.map((i)=>{
              
         return(
        
              <div className="single-item" >
                <div className="inner-box" >

                  <div className="icon-box" ><i className="fas fa-check" /></div>
                  <figure className="image-box" >
                  <img src={i.image} style={{width:"250px",height:"150px"}} />
                
                  
                  </figure> <br></br> <br></br>
                  <h4>{i.name}</h4>
                  <p><span style={{fontSize:"19px",color:"black"}}>Price</span> - {i.price}</p>
                   <p><span style={{fontSize:"19px",color:"black"}}>Size</span> - {i.size}</p>
                </div>
              </div>
                 )
                })}
            </div>
          </div>
         </section>
      </section>
  

   


      
     

      <Footer />
      <Helmet>
        <script src="assets/js/jquery.js"></script>
        <script src="assets/js/popper.min.js"></script>
        <script src="assets/js/bootstrap.min.js"></script>
        <script src="assets/js/owl.js"></script>
        <script src="assets/js/wow.js"></script>
        <script src="assets/js/validation.js"></script>
        <script src="assets/js/jquery.fancybox.js"></script>
        <script src="assets/js/appear.js"></script>
        <script src="assets/js/scrollbar.js"></script>
        <script src="assets/js/isotope.js"></script>

        <script src="assets/js/script.js"></script>
      </Helmet>
    </div>
  );
}
export default Market;
